import { render } from "./PackageGuideModal.vue?vue&type=template&id=367f501c&scoped=true&ts=true"
import script from "./PackageGuideModal.vue?vue&type=script&lang=ts"
export * from "./PackageGuideModal.vue?vue&type=script&lang=ts"

import "./PackageGuideModal.vue?vue&type=style&index=0&id=367f501c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367f501c"]])

export default __exports__